/* eslint-disable @typescript-eslint/member-ordering */
import { Component, inject, input, InputSignal, output, OutputEmitterRef, signal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ShopProductListItemBaseModel, TopLevelCategoryNode } from '@libs/shop/models';
import { ViewportService } from '@libs/shared/services';
import { ShoppingListItemSkeletonComponent } from '../../shopping-list';
import { OrderItemComponent } from '../order-item';

@Component({
  selector: 'ui-order-item-category-list',
  imports: [OrderItemComponent, ShoppingListItemSkeletonComponent],
  templateUrl: './order-item-category-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './order-item-category-list.component.scss',
})
export class OrderItemCategoryListComponent {
  private readonly viewportService: ViewportService = inject(ViewportService);
  public category: InputSignal<TopLevelCategoryNode<ShopProductListItemBaseModel>> = input.required();
  public skeletonRenderArray: Signal<number[]> = signal(new Array<number>(5).fill(0));

  public isMobile: Signal<boolean> = toSignal(this.viewportService.isMobile(), { initialValue: false });

  public itemQuantityChanged: OutputEmitterRef<ShopProductListItemBaseModel> = output();
  public itemRemoved: OutputEmitterRef<ShopProductListItemBaseModel> = output();
}
